// closure to limit how often (in ms) an event handler can be fired.
export default function debounce (func, timeout = 400) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => { func.apply(this, args) }, timeout)
  }
}
